import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';

import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { GroupMatchExclusionsFormComponent } from './group-match-exclusions-form.component';

@NgModule({
  declarations: [GroupMatchExclusionsFormComponent],
  exports: [GroupMatchExclusionsFormComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatIconModule,
    NzToolTipModule,
    NzTreeSelectModule,
    TranslationLookupModule,
  ],
})
export class GroupMatchExclusionsFormModule {}
